module.exports = __webpack_public_path__ + "static/img/DSC_1563_O1.9da4dabd.png";